import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ZapIcon, BrainIcon, CompassIcon, SettingsIcon } from 'lucide-react';
export function IncludesSection() {
  const results = [{
    icon: <ZapIcon className="w-6 h-6 text-sand" data-id="element-171" />,
    title: 'Energía estable todo el día',
    subtitle: 'Sin crashes',
    description: 'Tu cuerpo regulado produce energía constante. No más caídas a las 3pm.'
  }, {
    icon: <BrainIcon className="w-6 h-6 text-amber" data-id="element-172" />,
    title: 'Mente en silencio',
    subtitle: 'Menos ruido, más foco',
    description: 'El ruido mental baja. Pensás con claridad. Decidís mejor.'
  }, {
    icon: <CompassIcon className="w-6 h-6 text-offwhite" data-id="element-173" />,
    title: 'Dirección clara',
    subtitle: 'Sabés qué hacer y qué soltar',
    description: 'Dejás de girar en círculos. Cada día tiene propósito.'
  }, {
    icon: <SettingsIcon className="w-6 h-6 text-sand-light" data-id="element-174" />,
    title: 'Sistema diario simple',
    subtitle: '30–45 min, sin pensar',
    description: 'Un sistema que se ejecuta solo. Sin motivación. Sin fuerza de voluntad.'
  }];
  return <section id="includes" className="py-10 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-175">
      <div className="max-w-4xl mx-auto px-6" data-id="element-176">
        <FadeIn className="text-center mb-12 md:mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-4" data-id="element-178">
            Al día 7 vas a tener:
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-5 md:gap-6" data-id="element-179">
          {results.map((result, idx) => <FadeIn key={idx} delay={idx * 0.12} direction="up" className="bg-charcoal border border-charcoal-light rounded-sm p-7 md:p-8" data-id="element-180">
              <div className="flex items-start gap-4" data-id="element-181">
                <div className="bg-charcoal-dark p-3 rounded-sm border border-charcoal-light shrink-0" data-id="element-182">
                  {result.icon}
                </div>
                <div data-id="element-183">
                  <div className="flex items-baseline gap-2 flex-wrap" data-id="element-184">
                    <h3 className="text-lg font-heading font-bold text-offwhite" data-id="element-185">
                      {result.title}
                    </h3>
                  </div>
                  <p className="text-sm font-medium text-sand/70 uppercase tracking-wider mt-1" data-id="element-186">
                    {result.subtitle}
                  </p>
                  <p className="text-offwhite-dim text-sm leading-relaxed mt-3" data-id="element-187">
                    {result.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}